import React from "react";

const RESULT = {
  passed: { icon: "✓", className: "text-success" },
  failed: { icon: "✗", className: "text-danger" },
  skipped: { icon: "–", className: "text-muted" },
  info: { icon: "→", className: "text-primary" },
};

// Step-by-step record of how a Step 5 matching layer (and any custom rule
// after it) reached a field's score -- the field's score_trace.
const ScoreTrace = ({ trace, title = "How the match score was reached" }) => {
  if (!trace || trace.length === 0) return null;

  return (
    <div className="small px-2 py-1" style={{ background: "#f8f9fa" }}>
      <div className="text-muted text-uppercase mb-1" style={{ fontSize: "10px" }}>
        {title}
      </div>
      {trace.map((step, i) => {
        const r = RESULT[step.result] || RESULT.info;
        return (
          <div key={i} className={i > 0 ? "border-top py-1" : "py-1"}>
            <span className={r.className} style={{ display: "inline-block", width: "16px" }}>
              {r.icon}
            </span>
            <strong>{step.check}</strong>
            <div style={{ paddingLeft: "16px" }}>{step.detail}</div>
            {step.runners_up && step.runners_up.length > 0 && (
              <div className="text-muted" style={{ paddingLeft: "16px" }}>
                Runners-up: {step.runners_up.map((c) => `${c.name} (${c.similarity})`).join(", ")}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ScoreTrace;
